module.exports = __webpack_public_path__ + "static/media/worker-img4.e61f15e2.webp";